export default __webpack_public_path__ + "static/media/approve.e88ced02.svg";